<template>
     <div>
           <img  :src="src"  :style="outstyle" :alt="tag"  v-if="!domain" />
           <img  :src="src1" :style="outstyle"   v-else />

    </div>
</template>

<script>
export default {
  name: 'imgPath',

  props: {
      src: {
          type: String,
          default: ''
      },
      domain: {
          type: String,
          default: ''
      },
      outstyle: {
          default: ''
      },
      tag:{
        type: String,
        default: ''
      }
  },

  data () {
    return {
      src1: "",
      index:0,
      domain1: "jusewebapp.zmelo.com",
      domain2: "jusexcx.zmelo.com"
    }
  },

  mounted(){

      if(this.domain.indexOf('jusewebapp.oss-cn-hangzhou.aliyuncs.com')!=-1){
            this.index= this.domain.indexOf('jusewebapp.oss-cn-hangzhou.aliyuncs.com');
            this.src1= this.domain.substring(0,this.index) + this.domain1 + this.domain.substring(this.index+39);
      }
      
     
      if(this.domain.indexOf('jusexcx.oss-cn-hangzhou.aliyuncs.com')!=-1){
        this.index= this.domain.indexOf('jusexcx.oss-cn-hangzhou.aliyuncs.com');
        this.src1= this.domain.substring(0,this.index) + this.domain2 + this.domain.substring(this.index+36)
      }

  }
}


</script>


<style scoped>


</style>


// WEBPACK FOOTER //
// imgPath.vue